export class GestionAfiliado_Documentos {
    id: number;
    nombre: string;
    archivo: File;
    orden: number;
}